<script>
  import { link, location } from 'svelte-spa-router';
  import active from 'svelte-spa-router/active';
  import IoIosClose from 'svelte-icons/io/IoIosClose.svelte';

  import navegacaoStore from '../store';

  let dados;
  let width;
  let pdf_file;

  navegacaoStore.subscribe((dadosStore) => {
    dados = dadosStore;
  });

  let timestampTrick = Date.now();

  pdf_file =
    dados.pdfPath +
    'SENAPPEN_ATENCAO_AS_MULHERES_MODULO_' +
    dados.modulo +
    '.pdf?timestamp=' +
    timestampTrick;

  const toggleSidebar = (mob = false) => {
    navegacaoStore.update((dadosStore) => {
      return { ...dadosStore, sidebarAberta: !dados.sidebarAberta };
    });
  };
  const updatePaginaAtual = () => {
    width < 767 && toggleSidebar();
    navegacaoStore.update((dadosStore) => {
      return { ...dadosStore, paginaAtual: Number($location.split('/')[1]) };
    });
  };
  // let isPressed = false;
  // const toggleSiglas = () => {
  //   console.log('toggle siglas');
  //   isPressed = !isPressed;
  //   navegacaoStore.update((dadosStore) => {
  //     return { ...dadosStore, siglasOn: !dados.siglasOn };
  //   });
  // };
</script>

<svelte:window bind:innerWidth={width} />
<div
  class={dados.sidebarAberta ? 'fundo-mobile active' : 'fundo-mobile'}
  on:click={toggleSidebar}
/>
<div class="hamburger" on:click={() => toggleSidebar(true)}>
  <svg width="32" height="25" viewBox="0 0 32 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="32" height="5" rx="2.5" fill="white" />
    <rect y="10" width="32" height="5" rx="2.5" fill="white" />
    <rect y="20" width="32" height="5" rx="2.5" fill="white" />
  </svg>
</div>
<div class={dados.sidebarAberta ? 'sidebar open' : 'sidebar'}>
  <div class="toggle-menu" on:click={toggleSidebar}>
    <span class="icone">
      <svg width="8" height="11" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1.18645 7.82199C0.612441 7.42431 0.612442 6.57569 1.18645 6.17801L9.68051
          0.293151C10.3437 -0.166329 11.25 0.308327 11.25 1.11515L11.25 12.8849C11.25 13.6917
          10.3437 14.1663 9.6805 13.7069L1.18645 7.82199Z"
          fill="#ddd"
        />
      </svg>
      <svg width="8" height="11" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1.18645 7.82199C0.612441 7.42431 0.612442 6.57569 1.18645 6.17801L9.68051
          0.293151C10.3437 -0.166329 11.25 0.308327 11.25 1.11515L11.25 12.8849C11.25 13.6917
          10.3437 14.1663 9.6805 13.7069L1.18645 7.82199Z"
          fill="#ddd"
        />
      </svg>
    </span>
    <span class="titulo">
      <span class="abrir">abrir</span>
      <span class="fechar">fechar</span>
      <br />
      menu
    </span>
  </div>
  <div class="fechar-mobile" on:click={toggleSidebar}>
    <!-- <span class="titulo">FECHAR</span> -->
    <span class="icone">
      <IoIosClose />
    </span>
  </div>

  <div class="sidebar-content">
    <a class="modulo introducao">
      <span class="fechado">M{dados.modulo}</span>
      <span class="aberto">Módulo {dados.modulo}</span>
    </a>

    {#each dados.paginas as pagina, i}
      <!-- {#if i > 0 && i < dados.paginas.length} -->
      <a
        on:click={updatePaginaAtual}
        href="/{i + 1}"
        use:link
        use:active={{ className: 'active' }}
        class="unidade"
      >
        <div>
          {#if i == 0}
            <span class="fechado">A</span>
            <span class="aberto">{pagina}</span>
          {:else if i == dados.paginas.length - 1}
            <span class="fechado">R</span>
            <span class="aberto">{pagina}</span>
          {:else}
            <span class="fechado">{i}</span>
            <span class="aberto">{pagina}</span>
          {/if}
        </div>
      </a>
      <!-- {/if} -->
    {/each}
  </div>
</div>

<style>
  /* Teste Vercel */
  /* width */
  ::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0);
  }

  .sidebar.open .unidade div {
    width: 175px;
    /* width: calc(100% - 0px); */
    overflow-x: hidden;
  }
  .sidebar .unidade div {
    /* width: calc(100% - 105px); */
    height: 50px;
    background: white;
    border-radius: 0 30px 30px 0;
    display: flex;
    align-items: center;
    overflow-x: hidden;
    padding: 0 0 0 0;
    /* transition: all 300ms ease; */
    width: 50px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: rgba(182, 182, 182, 0);
    border-radius: 10px;
    padding: 5px 0;
  }

  .sidebar {
    /* padding: 5px; */
    padding: 10px 0px;
    position: fixed;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    background: var(--VERDE_CLARO);
    border-radius: 0 35px 35px 0;
    z-index: 102;
    filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.2));
    transition: all 200ms ease;
    width: 70px;
    transform: translateY(-50%);
    top: 50%;
    overflow-x: hidden;
  }

  .sidebar:hover ::-webkit-scrollbar-thumb {
    background: rgba(182, 182, 182, 0.308);
  }

  a .titulo {
    position: absolute;
    width: 100px;
    /* left: -20px; */
    transition:
      left 200ms ease,
      opacity 100ms ease;
    opacity: 0;
    font-size: 24px;
    z-index: 203;
  }

  .sidebar.open {
    width: 195px;
    left: 0;
  }

  .sidebar.open a .titulo {
    left: 24px;
    opacity: 1;
    transition:
      left 100ms ease,
      opacity 200ms ease;
    font-family: var(--FONT_INTER);
    color: var(--VERDE_CLARO);
    /* text-transform: uppercase; */
    font-size: 20px;
  }

  a.modulo.introducao {
    font-family: var(--FONT_INTER);
    padding-left: 3px;
    font-weight: 500;
  }
  .sidebar.open .modulo.introducao .aberto {
    font-family: var(--FONT_INTER);
    text-transform: uppercase;
  }

  .sidebar.open button:hover .titulo,
  .sidebar :global(button.active .titulo) {
    font-weight: 500;
  }
  .sidebar :global(button.active .path-brasao) {
    fill: var(--COR_MOD_TER);
  }

  .sidebar :global(button:hover .path-brasao) {
    fill: var(--COR_MOD_SEC);
  }
  .sidebar.open button .titulo {
    left: 24px;
    opacity: 1;
    transition:
      left 100ms ease,
      opacity 200ms ease;
    font-family: var(--FONT_INTER);
    /* color: #fff; */
    /* text-transform: uppercase; */
    font-size: 20px;
  }

  .sidebar.open a.unidade {
    font-weight: 500;
  }

  a {
    padding: 10px 0px;
    display: flex;
    align-items: center;
    position: relative;
    text-decoration: none;
    /* word-break: normal; */
    font-weight: 600;
    font-size: 20px;
    color: var(--VERDE_CLARO);
  }

  a .icone {
    position: relative;
    z-index: 204;
  }
  a svg {
    width: 52px;
    height: 52px;
    transition: all 100ms ease;
  }
  .unidade svg {
    filter: drop-shadow(0px 3px 3px rgba(0, 0, 0, 0.2));
    width: 52px;
    height: 52px;
    transition: all 100ms ease;
    margin-left: 0px;
  }

  .numero-icone {
    position: absolute;
    left: 24px;
    color: var(--VERDE_CLARO);
    font-size: 24px;
    font-family: var(--FONT_INTER);
    font-weight: 700;
    z-index: 232;
  }
  .sidebar-content a:nth-child(3) .numero-icone {
    left: 26px;
  }
  .toggle-menu {
    display: flex;
    font-size: 13px;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: center;
    line-height: 1;
    padding: 7px 5px 5px 1px;
    cursor: pointer;
    transition: all 200ms ease;
    user-select: none;
    color: #ddd;
  }

  .sidebar:has(.toggle-menu:hover) {
    width: 75px;
  }

  /* deploy fail */

  .toggle-menu:hover svg path {
    fill: #fff;
  }

  .toggle-menu:hover .titulo {
    color: #fff;
  }

  .sidebar.open:has(.toggle-menu:hover) {
    width: 195px;
  }
  .toggle-menu .fechar {
    display: none;
  }
  .sidebar.open .toggle-menu .fechar {
    display: inline-block;
  }
  .sidebar.open .toggle-menu .abrir {
    display: none;
  }
  .sidebar.open .toggle-menu {
    flex-direction: row;
  }

  .toggle-menu .icone {
    display: flex;
    transform: rotateY(180deg);
    transition: all 200ms ease;
  }
  .sidebar.open .toggle-menu .icone {
    transform: rotateY(0);
  }
  .toggle-menu .titulo {
    margin: 0 6px 0 6px;
    /* color: #fff; */
    font-family: var(--FONT_INTER);
    font-weight: 600;
  }

  .path-brasao {
    fill: #fff;
  }

  .sidebar.open a:hover .titulo,
  .sidebar :global(a.active .titulo) {
    /* color: black; */
    font-weight: 600;
  }
  .sidebar :global(a.active .path-brasao) {
    fill: var(--COR_MOD_TER);
  }

  .sidebar.open a div {
    transition: none;
  }
  .sidebar a div {
    transition: all 300ms ease;
  }

  .sidebar.open a.unidade div:hover {
    padding-left: 0;
  }

  .sidebar.open a.unidade.active div:hover {
    padding-left: 0;
  }

  .sidebar.open a.unidade.active div {
    padding-left: 0px;
    width: 185px;
  }
  .sidebar a div:hover {
    background: var(--MARROM);
    color: var(--BRANCO);
    padding-right: 0px;
    /* width: 55px; */
    /* padding-left: 10px; */
    transition: all 300ms ease;
  }

  .sidebar :global(a.unidade.active div:hover) {
    padding-right: 0px;
  }
  .sidebar :global(a.unidade.active div) {
    background: var(--MARROM);
    color: var(--BRANCO);
    padding-right: 0px;
    width: 60px;
    padding-left: 10px;
  }

  .hamburger {
    display: none;
  }

  .fundo-mobile {
    position: fixed;
    left: 0;
    top: 0;
    height: 100vh;
    width: 100vw;
    overflow: hidden;
    background: rgba(97, 97, 97, 0.281);
    z-index: 102;
    display: none;
  }

  .fechar-mobile {
    display: none;
  }

  @media (max-width: 800px) {
    .hamburger {
      position: fixed;
      top: 15px;
      left: 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 40px;
      height: 40px;
      z-index: 101;
      background: linear-gradient(to right, var(--VERDE_CLARO), var(--MARROM));
      border-radius: 10px;
      cursor: pointer;
      filter: drop-shadow(0 0 2px #00000099);
    }
    .hamburger svg {
      fill: #fff;
      width: 22px;
    }
    .sidebar {
      left: -150px;
    }
    .sidebar.open .fechar-mobile {
      left: 0;
    }
    .fechar-mobile .icone {
      width: 30px;
    }
  }

  .sidebar-content {
    /* width: 100%; */
    display: grid;
    grid-template-columns: 1fr;
    overflow-x: hidden;
  }

  @media (max-height: 700px) {
    .sidebar-content {
      overflow-y: scroll;
      overflow-x: hidden;
    }
  }

  .sidebar .modulo {
    font-size: 20px;
    margin: 10px 0 5px 5px;
    padding: 0;
    opacity: 1;
    width: 150px;
  }
  .sidebar .modulo .aberto {
    display: none;
  }
  .sidebar.open .modulo {
    height: auto;
    display: inline-block;
    visibility: visible;
    opacity: 1;
    transition: all 300ms ease;
  }
  .sidebar.open .modulo .fechado {
    display: none;
  }
  .sidebar.open .modulo .aberto {
    display: inline;
  }
  .sidebar .unidade .fechado {
    display: inline;
    padding-left: 13px;
  }
  .sidebar .unidade .aberto {
    display: none;
  }
  .sidebar.open .unidade .fechado {
    display: none;
  }
  .sidebar.open .unidade .aberto {
    display: inline;
    padding-left: 13px;
  }

  .modulo.introducao {
    font-weight: 600;
    color: white;
    font-size: 22px;
    padding-left: 3px;
  }
</style>
